import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import axios from "axios";
import VueAxios from "vue-axios";

const configurationSweetAlert = {
  confirmButtonText: "Cerrar",
  cancelButtonText: "Cancelar",
  timerProgressBar: true,
  showCloseButton: false,
  closeButtonAriaLabel: "Cerrar mensaje",
  allowEscapeKey: false,
};

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.timeout = 60000;

const token = localStorage.getItem("token");
if (token) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (process.env.NODE_ENV !== "production") {
      console.error("Error API:", error);
    }

    const mensaje =
      error?.response?.data?.message ||
      error?.response?.data?.mensaje ||
      error?.message ||
      "No fue posible procesar la solicitud.";

    return Promise.reject({
      ...error,
      message: mensaje,
    });
  },
);

const app = createApp(App);

app.config.errorHandler = (err, instance, info) => {
  if (process.env.NODE_ENV !== "production") {
    console.error("Vue error:", err, info);
  }
};

// No silenciar todos los errores globales
window.onerror = function (message, source, lineno, colno, error) {
  if (process.env.NODE_ENV !== "production") {
    console.error("Window error:", message, error);
  }

  return false;
};

window.onunhandledrejection = function (event) {
  if (process.env.NODE_ENV !== "production") {
    console.error("Unhandled rejection:", event.reason);
  }
};

app.use(vuetify);
app.use(store);
app.use(router);
app.use(VueAxios, axios);
app.use(VueSweetalert2, configurationSweetAlert);
app.mount("#app");